import BooleanType from "../enums/boolean-type";
import ClockType from "../enums/clock-type";
import FieldLength from "../enums/field-length";
import GoalPost from "../enums/goal-post";
import KickoffSkip from "../enums/kickoff-skip";
import TeamLoss from "../enums/team-loss";
import ParticipationStyle from "../enums/participation-style";

const customFormData = {
    general: {
        title: "Game information",
        endZoneLength: {
            title: "End Zone Length (yds)"
        },
        includeEndZoneYardage: {
            title: "Show End Zone Yards",
            options: Object.values(BooleanType)
        },
        fieldLength: {
            title: "Field Length (yds)",
            options: Object.values(FieldLength).filter(
                ({ code }) => code % 2 === 0
            )
        },
        fieldWidth: {
            title: "Field Width (yds)"
        },
        // TODO: this property shouldn't be here. This is part of the flag config.
        firstDownFlagStyle: {
            disabled: true
        },
        firstDownYards: {
            disabled: true
        },
        minutesByPeriod: {
            title: "Period Length (min)"
        },

        periodsInRegulation: {
            title: "Number of Periods"
        },
        redZoneLength: {
            title: "Red Zone Length (yds)"
        },
        zoneLength: {
            title: "Zone Length (yds)",
            disabled: true
        },
        otTimeControl: {
            title: "OT Time Control",
            options: Object.values(BooleanType)
        },
        autoFairCatchTb: {
            title: "Fair Catch Touchback",
            options: Object.values(BooleanType)
        },
        rushType: {
            title: "Rush Type",
            options: Object.values(BooleanType)
        },
        passType: {
            title: "Pass Type",
            options: Object.values(BooleanType)
        },
        // Legacy keys — clock settings live in the clock section now, but
        // configs saved before the move may still carry them in general.
        clockType: {
            disabled: true
        },
        runningClock: {
            disabled: true
        },
        spikeTeamAttOnly: {
            title: "Spike as Team Attempt Only",
            options: Object.values(BooleanType)
        },
        touchdownsCountAsFirstDowns: {
            title: "Touchdowns Count as 1st Downs",
            options: Object.values(BooleanType)
        },
        teamLossOnly: {
            title: "Team Loss Only",
            options: Object.values(TeamLoss),
            multiselect: true
        },
        collectStatsOnPat: {
            title: "Collect Additional Stats on PAT",
            options: Object.values(BooleanType)
        },
        collectStatsForOnSideKicks: {
            title: "Collect Stats For On Side Kicks",
            options: Object.values(BooleanType)
        },
        teamZoneQty: {
            disabled: true
        },
        promptToSkipKickoff: {
            title: "Prompt To Forego Kickoff",
            options: Object.values(KickoffSkip),
            multiselect: true
        },
        participationStyle: {
            title: "Participation Style",
            options: Object.values(ParticipationStyle)
        }
    },
    clock: {
        title: "Clock",
        // editableAfterStart: clock settings stay editable while the rest of
        // the form is locked mid-game (the save guard only allows clock-
        // section changes through).
        clockType: {
            title: "Clock Type",
            options: Object.values(ClockType),
            editableAfterStart: true
        },
        // No options: plain booleans render as a Switch in the form.
        runningClock: {
            title: "Running Clock",
            editableAfterStart: true
        }
    },
    spots: {
        title: "Default Yardlines",
        KOTouchback: {
            title: "KO Touchback"
        },
        PATTry: {
            title: "PAT Try"
        },
        safetyKO: {
            title: "Safety KO"
        },
        driveStartingYardline: {
            title: "Drive Starting Yardline"
        },
        touchbackYardline: {
            title: "Touchback Yardline"
        },
        overtimeStartingYardline: {
            title: "Overtime Starting Yardline"
        },
        kickoff: {
            title: "Kickoff Yardline"
        },
        otherTouchback: {
            disabled: true
        },
        rougeYardline: {
            title: "Rouge Yardline"
        },
        spotsPatScoreOption1: {
            disabled: true
        },
        spotsPatScoreOption2: {
            disabled: true
        },
        spotsPatScoreOption3: {
            disabled: true
        },
        goalPostLocation: {
            title: "Goal Post Location",
            options: Object.values(GoalPost)
        },
        missedFieldGoalMinSpot: {
            disabled: true
        },
        missedFieldGoalSpot: {
            disabled: true
        }
    },
    scoring: {
        title: "Scoring Information",
        defensivePAT: {
            title: "Defensive PAT"
        },
        kickPAT: {
            title: "Kick PAT"
        },
        runPAT: {
            title: "Pass/Run PAT"
        },
        touchdown: {
            title: "Touchdown Score"
        },
        safety: {
            title: "Safety Score"
        },
        rougePoints: {
            title: "Rouge Score"
        },
        fieldGoal: {
            disabled: true
        },
        playSummary: {
            disabled: true
        },
        scoringPatScoreOption1: {
            disabled: true
        },
        scoringPatScoreOption2: {
            disabled: true
        },
        scoringPatScoreOption3: {
            disabled: true
        }
    }
};

export default customFormData;
